import { render, staticRenderFns } from "./ExternalIncomeTable.vue?vue&type=template&id=76fe09ea&scoped=true&"
import script from "./ExternalIncomeTable.vue?vue&type=script&lang=ts&"
export * from "./ExternalIncomeTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fe09ea",
  null
  
)

export default component.exports